import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class Amenity {
    static amenity() {
        return axios
            .get(API_PATHS.getAmenity)
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static uploadAmenity(item) {
        return axios
            .post(API_PATHS.postAmenity,
                item
            )
            .then((response) => {
                if (response.data) {
                     // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static removeUserDetails() {
        localStorage.removeItem("user");
    }

    static getUserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default Amenity;